import HomeIndexFPage from '@/modules/home/indexf';
import HomeIndexMPage from '@/modules/home/indexm';
import MyContext from '@/shared/contexts/AppContext';
import RelatoriosAtividadesPage from '../reports/presentation/pages/RelatoriosAtividadesPage';
import { AttendanceSheetsPerMonthPage } from '../business/attendance-sheet/presentation/pages/perMonth/PerMonthPage';
import { Fragment } from 'react/jsx-runtime';
import { ModuloSistema } from '@/shared/constants/modulos-sistema.enum';
import { useContext } from 'react';

const HomeIndexPage = () => {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');
  const { state } = context;

  return (
    <Fragment>
      {state.modulo == ModuloSistema.Ferias && <HomeIndexFPage />}
      {state.modulo == ModuloSistema.Movimentacoes && <HomeIndexMPage />}
      {state.modulo == ModuloSistema.FolhaFrequencia && (<AttendanceSheetsPerMonthPage />)}
      {state.modulo == ModuloSistema.RelatoriosAtividades && (<RelatoriosAtividadesPage />)}
    </Fragment>
  );
};

export default HomeIndexPage;